import { PaymentModel } from './payment.model';

export class PaginationPaymentModel {
  public list: PaymentModel[];
  public size: number;
  public totalAmount: number;
  public totalAmountGeneral: number;
  public totalPage: number;

  constructor() {
    this.list = new Array<PaymentModel>();
    this.size = 0;
    this.totalAmount = 0;
    this.totalPage = 0;
  }

  public isPresent(): boolean {
    return this.size != 0;
  }
}
